var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.hasData
    ? _c(
        "div",
        { staticClass: "h-full" },
        [
          _c(
            "Processing",
            {
              attrs: {
                processing: _vm.loading,
                backgroundOpacity: 25,
                spinner: "",
              },
            },
            [_vm._t("default")],
            2
          ),
        ],
        1
      )
    : _c(
        "div",
        {
          staticClass: "h-full flex justify-center wrapper",
          class: _vm.spinnerCenteredStyles,
        },
        [
          _vm.loading ? _c("Spinner") : _vm._e(),
          _vm.showNoInformation
            ? _c("h3", { staticClass: "leading-7 text-xl" }, [
                _vm._v(" You currently have no clients. "),
                _c("br"),
                _vm._v(
                  " Once you have created a client, this information will appear here in the scheduler view. "
                ),
                _c("br"),
                _vm._v(" Click on 'Create Client' to get started."),
                _c("br"),
              ])
            : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }